import Button from "Components/Global/Buttons";
import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

const Modal = ({
  open,
  children,
  title,
  subtitle,
  text,
  allowDismiss,
  showButtons = true,
  showBackButton = true,
  showSubmitButton,
  submitButtonText = "Enviar",
  submitButtonType = "button",
  onSubmit = () => {},
  onDismiss = () => {},
}) => {
  return (
    <S.Wrapper open={open}>
      <S.Container>
        <S.Content>
          <S.Header>
            <S.Row>
              {title && <h1>{title}</h1>}
              {allowDismiss && (
                <S.CloseButton onClick={onDismiss}>
                  <GetIcon name="X" size="lg" />
                </S.CloseButton>
              )}
            </S.Row>

            {subtitle && <span>{subtitle}</span>}
          </S.Header>

          {text && <p>{text}</p>}

          {children}
        </S.Content>

        {showButtons && (
          <S.Buttons>
            {showBackButton && (
              <Button
                text="Fechar"
                onClick={onDismiss}
                disabled={!allowDismiss}
                outline
              />
            )}

            {showSubmitButton && (
              <Button
                text={submitButtonText}
                type={submitButtonType}
                disabled={false}
                onClick={submitButtonType === "button" ? onSubmit : null}
              />
            )}
          </S.Buttons>
        )}
      </S.Container>
    </S.Wrapper>
  );
};

export default Modal;
